import { Card, Icon } from 'ui/components/primitives';
import { ToolTip } from 'ui/components/compounds/Tooltip';

import type { BalanceProps } from './Balance.d';
import { Balance } from './Balance.styles';
import { FloraTypography } from '@grupoboticario/flora-react';
import { isMobile } from 'core/use-cases/app/helpers';
import { theme } from 'ui/theme';

const CartBalance = ({ profit, total }: BalanceProps) => (
  <Balance.Container>
    <Balance.Component data-testid="cart-balance">
      <FloraTypography
        as="h6"
        fontSize="subtitle"
        viewport={isMobile() ? 'mobile' : 'desktop'}
        css={{ margin: `${theme.space['2']} ${theme.space['4']}`, marginLeft: 0 }}
      >
        Resumo dos valores
      </FloraTypography>
      <Card radius="rounded">
        <Balance.Content data-spacing-bottom="none" data-spacing-top="none">
          <Balance.TotalValue>
            Total do pedido{' '}
            <ToolTip
              align="center"
              content="Valores estimados. Os descontos e promoções serão calculados na etapa de pagamento."
              label="total-do-pedido"
              withIcon
            >
              <Icon.Info size="s" />
            </ToolTip>
          </Balance.TotalValue>

          <Balance.TotalValue>{total}</Balance.TotalValue>
        </Balance.Content>
      </Card>

      <Balance.Space />

      <Card>
        <Balance.Content data-spacing="none">
          <Balance.Info>
            Lucro previsto{' '}
            <ToolTip
              align="center"
              content="Mostramos uma previsão, pois seu lucro pode variar de acordo com as combinações de produtos no seu pedido ou sua estratégia de vendas. Aproveite as promoções para lucrar ainda mais!"
              label="lucro-previsto"
              isPdp={false}
              withIcon
            >
              <Icon.Info size="s" />
            </ToolTip>
          </Balance.Info>
          <span>{profit}</span>
        </Balance.Content>
      </Card>
    </Balance.Component>
  </Balance.Container>
);

export default CartBalance;
